import SkeletonBlogGrid from "@modules/skeleton/blog_grid";
import { useGetFeaturedBlogQuery } from "@redux/blog/blogApi/blogApi";
import { Fragment } from "react";
import BlogBoxGrid from "../components/blog_grid_box";
import styles from "./blog_featured.module.scss";

export const BlogFeatured = () => {
  const { data, isLoading: loading, error } = useGetFeaturedBlogQuery();
  const posts = data?.data;
  let content;
  if (loading) {
    content = (
      <div>
        <SkeletonBlogGrid />
      </div>
    );
  }
  if (!loading && error) {
    content = { error };
  }
  if (!error && !loading) {
    content = (
      <>
        {posts?.length > 0 ? (
          <div className={styles.blog_hero_wrapper}>
            {posts?.map((post, i) => (
              <BlogBoxGrid
                post={post}
                key={i}
                spanTwoWithOverlay={posts.length > 1 && i === 0}
                blogTitle={post?.title}
                blogLink={`/blog/${post?.slug}`}
                categories={post?.categories}
                featureImage={post?.image}
                videoType={post?.videoType}
                summary={post?.summary}
              />
            ))}
          </div>
        ) : (
          <Fragment>
            <>Data not found</>
          </Fragment>
        )}
      </>
    );
  }
  return (
    <Fragment>
      <section className={styles.section_blog_hero}>
        <div className="container">
          <div className={styles.wrapper}>{content}</div>
        </div>
      </section>
    </Fragment>
  );
};

export default BlogFeatured;
